(function(){
class BoutiqueGallery extends HTMLElement {
    constructor() {
      super();

        if(!window.PhotoSwipeLightbox || !window.PhotoSwipe){
            console.warn('PhotoSwipeLightbox or PhotoSwipe not found. Gallery couldn\'t be initialized.');
            return;
        }

      this.galleryItemsSelector = '[data-gallery-item]';
      this.pswpItemsSelector = '[data-pswp-item]';
      this.galleryItemsDataSource = [];
      this.galleryItems;
      this.lightBox;
      this.leftArrowSVGString = '<svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7775 24.6665L1.66634 12.9998M1.66634 12.9998L12.7775 1.33317M1.66634 12.9998L28.333 12.9998" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      this.rightArrowSVGString = '<svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.2225 1.3335L28.3337 13.0002M28.3337 13.0002L17.2225 24.6668M28.3337 13.0002L1.66699 13.0002" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      this.closeSVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.33 1L1 22.33M22.33 22.33L1 0.999995" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>';
      this.zoomSVG = '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.9067 22.6813C23.5098 22.2973 22.8767 22.3078 22.4927 22.7047C22.1087 23.1016 22.1192 23.7347 22.5161 24.1187L23.9067 22.6813ZM28.3047 29.7187C28.7016 30.1027 29.3347 30.0922 29.7187 29.6953C30.1027 29.2984 30.0922 28.6653 29.6953 28.2813L28.3047 29.7187ZM13 19C13 19.5523 13.4477 20 14 20C14.5523 20 15 19.5523 15 19H13ZM15 9C15 8.44772 14.5523 8 14 8C13.4477 8 13 8.44772 13 9H15ZM9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15V13ZM19 15C19.5523 15 20 14.5523 20 14C20 13.4477 19.5523 13 19 13V15ZM27.1333 14.0667H26.1333C26.1333 20.7309 20.7309 26.1333 14.0667 26.1333V27.1333V28.1333C21.8355 28.1333 28.1333 21.8355 28.1333 14.0667H27.1333ZM14.0667 27.1333V26.1333C7.40243 26.1333 2 20.7309 2 14.0667H1H0C0 21.8355 6.29786 28.1333 14.0667 28.1333V27.1333ZM1 14.0667H2C2 7.40243 7.40243 2 14.0667 2V1V0C6.29786 0 0 6.29786 0 14.0667H1ZM14.0667 1V2C20.7309 2 26.1333 7.40243 26.1333 14.0667H27.1333H28.1333C28.1333 6.29786 21.8355 0 14.0667 0V1ZM23.2114 23.4L22.5161 24.1187L28.3047 29.7187L29 29L29.6953 28.2813L23.9067 22.6813L23.2114 23.4ZM14 19H15V14H14H13V19H14ZM14 14H15V9H14H13V14H14ZM9 14V15H14V14V13H9V14ZM14 14V15H19V14V13H14V14Z" fill="black"/></svg>';
      this.galleryLoadMoreBtn = this.querySelector('[data-gallery-load-more]');


      this.fetchGalleryImages();
      this.fetchPSWPItems();
      this.initPSWPLightbox();
      this.initLoadMore();
    }

    fetchGalleryImages() {
        this.galleryItems = this.querySelectorAll(this.galleryItemsSelector);
    }

    fetchPSWPItems() {
        const _this = this;
        if(this.galleryItems && this.galleryItems.length > 0) {
            this.galleryItems.forEach(item => {
                const currentGalleryItem = item.querySelector(_this.pswpItemsSelector);
                if(item.getAttribute('data-gallery-item-loaded') === 'true' && currentGalleryItem) {

                    const itemImg = currentGalleryItem.querySelector('img');

                    _this.galleryItemsDataSource.push({
                        src: currentGalleryItem.getAttribute('href'),
                        width: currentGalleryItem.getAttribute('data-pswp-width'),
                        height: currentGalleryItem.getAttribute('data-pswp-height'),
                        alt: itemImg ? itemImg.getAttribute('alt') : '',
                        _galleryItem: currentGalleryItem
                    });
                }
            });
        }


    }

    initPSWPLightbox() {
        const _this = this;


        this.lightBox = new PhotoSwipeLightbox({
            arrowPrevSVG: _this.leftArrowSVGString,
            arrowNextSVG: _this.rightArrowSVGString,
            closeSVG: _this.closeSVG,
            zoomSVG: _this.zoomSVG,
            showHideAnimationType: 'fade',
            bgOpacity: 0.95,
            pswpModule: window.PhotoSwipe,
            dataSource: _this.galleryItemsDataSource,
            paddingFn: _this.getLightboxSpacing,
        });

        this.lightBox.init();

        this.addEventListener('click', e => {
            const currentGalleryItem = _this.getCurrentPswpItemUp(e.target);

            if(e.target && currentGalleryItem) {
                e.preventDefault();
                e.stopPropagation();

                _this.lightBox.options.dataSource.map((item, i) => {
                    if(item._galleryItem === currentGalleryItem) {
                        _this.lightBox.loadAndOpen(i);
                    }
                });

            }
        });
    }

    initLoadMore() {
        const _this = this;

        if(this.galleryLoadMoreBtn) {
            this.galleryLoadMoreBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();

                _this.galleryItems.forEach(item => {
                    if(item.getAttribute('data-gallery-item-loaded') !== 'true') {
                        item.setAttribute('data-gallery-item-loaded', true);
                        const currentGalleryItem = _this.getCurrentPswpItemDown(item);
                        const currentGalleryItemImage = currentGalleryItem.querySelector('img');
                        if(!currentGalleryItemImage) return;

                        _this.galleryItemsDataSource.push({
                            src: currentGalleryItem.getAttribute('href'),
                            width: currentGalleryItem.getAttribute('data-pswp-width'),
                            height: currentGalleryItem.getAttribute('data-pswp-height'),
                            alt: currentGalleryItemImage ? currentGalleryItemImage.getAttribute('alt') : '',
                            _galleryItem: currentGalleryItem
                        });

                        _this.setAttribute('data-gallery-loaded', true);
                    }
                });
            });
        }
    }
    getLightboxSpacing() {
        if(window.innerWidth >= 991) {
            return {
                top: window.innerWidth * 3 / 100,
                bottom: window.innerWidth * 3 / 100,
                left: window.innerWidth * 5 / 100,
                right: window.innerWidth * 5 / 100
            }
        } else if (window.innerWidth >= 768) {
            return {
                top: window.innerWidth * 3 / 100,
                bottom: window.innerWidth * 3 / 100,
                left: window.innerWidth * 8 / 100,
                right: window.innerWidth * 8 / 100
            }
        } else {
            return {
                top: window.innerWidth * 3 / 100,
                bottom: window.innerWidth * 3 / 100,
                left: window.innerWidth * 12 / 100,
                right: window.innerWidth * 12 / 100
            }
        }
    }

    getCurrentPswpItemUp(child) {
        return child.closest(this.pswpItemsSelector);
    }

    getCurrentGalleryItemUp(child) {
        return child.closest(this.galleryItemsSelector);
    }

    getCurrentPswpItemDown(parent) {
        return parent.querySelector(this.pswpItemsSelector);
    }

    getCurrentGalleryItemDown(parent) {
        return parent.querySelector(this.galleryItemsSelector);
    }

  }

  customElements.define('boutique-gallery', BoutiqueGallery);

})();